<template>
  <div>
    <v-row justify="center" class="mt-12">
      <v-col cols="5">
        <v-form @submit.prevent="submit" class="mt-12">
          <h2>login</h2>
          <v-text-field v-model="email" label="email" :error-messages="emailErrors"></v-text-field>
          <v-text-field type="password" v-model="password" label="password" :error-messages="passwordErrors"></v-text-field>
          <v-btn type="submit" :loading="$store.state.loading">Login</v-btn>
        </v-form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";

const loginValidator = function() {
  return !this.loginFailed;
};

export default {
  mixins: [validationMixin],
  data() {
    return {
      email: "",
      password: "",
      loginFailed: false
    };
  },
  methods: {
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {

        const credentials = {
            userName: this.email,
            password: this.password,
            application: 'app_bo'
        }
        this.$store.dispatch('login', credentials)
            .then(res => {
                this.$router.push('/')
            })
            .catch(err => {
              this.loginFailed = true
                if(err.response.data.errorCode === 10413){
                    this.loginFailed = true
               
                }                
            })
      }
    }
  },
  computed: {
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      if (!this.$v.email.email) errors.push("Please enter a valid email");
      if (!this.$v.email.required) errors.push("This field is required");
      if (!this.$v.email.loginValidator)
        errors.push("Wrong Username Or password");
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      if (!this.$v.password.required) errors.push("This field is required");
      if (!this.$v.password.loginValidator)
        errors.push("Wrong Username Or password");
      return errors;
    }
  },
  validations: {
    email: { required, email, loginValidator },
    password: { required, loginValidator }
  },
   watch: {
    email(newVal, oldVal) {
      if (oldVal !== "" && newVal === "") {
        this.loginFailed = false;
      }
    },
    password(newVal, oldVal) {
      if (oldVal !== "" && newVal !== oldVal) {
        this.loginFailed = false;
      }
    }
  }
};
</script>